import { createApp } from 'vue';
import PublicApp from './PublicApp.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'survey-core/survey-core.css';

createApp(PublicApp).mount('#app');
